/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Badge as RBadge } from 'reactstrap';

// eslint-disable-next-line react/prefer-stateless-function
class Badge extends React.Component {
  render() {
    return <RBadge {...this.props}>{this.props.children}</RBadge>;
  }
}

Badge.propTypes = {
  children: PropTypes.any,
};

export default Badge;
